import { ref, computed, watchEffect } from 'vue';
import { useHead } from '@vueuse/head';
import { getMetaData } from '../api/wordpress.js';

export const useWordPressMeta = (urlPath, options = {}) => {
    const {
        cacheKey = null,
        fallbackTitle = 'Default Title',
        fallbackDescription = 'Default Description'
    } = options;

    // Helper function to decode HTML entities
    const decodeHtmlEntities = (html) => {
        return html?.replace(/&([^;]+);/g, (entity, entityCode) => {
            const entities = {
                'amp': '&',
                'apos': "'",
                '#x27': "'",
                '#x2F': '/',
                '#39': "'",
                '#47': '/',
                'lt': '<',
                'gt': '>',
                'nbsp': ' ',
                'quot': '"',
                '#8211': '–',
                '#8217': "'"
            };
            return entities[entityCode] || entity;
        });
    };

    // Fetch meta data
    const { data: metaData, error, pending } = useAsyncData(
        cacheKey || `meta-${urlPath}`,
        async () => {
            try {
                console.log('Fetching meta data for:', urlPath);
                const metaResponse = await getMetaData(urlPath);
                console.log('Meta response:', metaResponse);
                return metaResponse.data || null;
            } catch (error) {
                console.error('Error fetching meta data:', error);
                return null;
            }
        },
        {
            server: true,
            static: true,
            lazy: false
        }
    );

    // Set meta tags when data is available
    watchEffect(() => {
        console.log('watchEffect triggered, metaData.value:', metaData.value);

        if (metaData.value?.parsed) {
            // Extract title from og:title meta tag
            const ogTitleMeta = metaData.value.parsed.meta.find(
                meta => meta.property === 'og:title'
            );
            const title = ogTitleMeta?.content || fallbackTitle;

            console.log('Setting meta tags with parsed data, title:', title);
            useHead({
                title,
                meta: metaData.value.parsed.meta,
                link: metaData.value.parsed.links || [],
                script: metaData.value.parsed.scripts || []
            });
        } else {
            console.log('Using fallback meta tags');
            // Fallback meta if API fails
            useHead({
                title: fallbackTitle,
                meta: [
                    { name: 'description', content: fallbackDescription }
                ]
            });
        }
    });

    return {
        metaData,
        error,
        isLoading: pending
    };
};